export default __webpack_public_path__ + "static/media/icon.933dc72b.jpg";